import './App.css';
import Header from './components/Header';
import Form from './components/Form'
function App() {
  return (
    <div className="App">
      <Header />
      <Form />
    </div>
  );
}
export default App;
